import {
  HTTP_STATUS_INTERNAL_SERVER_ERROR,
  HTTP_STATUS_NOT_FOUND,
} from '../../../constants/api'
import { getEmailMessageRaw, getEmailMessages } from '../Email.api'

export async function emailMessageProfileRawDataLoader({ params }) {
  const { mailUuid } = params

  try {
    const [rawRes, messagesRes] = await Promise.all([
      getEmailMessageRaw(mailUuid),
      getEmailMessages({ params: { uuid: [mailUuid] } }),
    ])

    const item = messagesRes?.data?.items?.[0]
    const rawText = rawRes?.data?.raw_text

    if (!item || !rawText) {
      throw new Response('Message not found', { status: HTTP_STATUS_NOT_FOUND })
    }

    return {
      ...item,
      rawText,
    }
  } catch (error) {
    if (error instanceof Response) {
      throw error
    }

    const status = error?.response?.status ?? HTTP_STATUS_INTERNAL_SERVER_ERROR
    const message =
      error?.response?.data?.message ??
      error?.message ??
      'Failed to load message raw data'

    throw new Response(message, { status })
  }
}
